import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27356074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "status-title" }
const _hoisted_3 = { class: "status-desc" }
const _hoisted_4 = {
  key: 0,
  class: "qrcode-box"
}
const _hoisted_5 = {
  key: 0,
  class: "qrcode-name"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qrcode-tip" }, "请使用微信扫码完成认证费用支付", -1))
const _hoisted_8 = {
  key: 1,
  class: "dispatch-box"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type-selector-label" }, "主体类型", -1))
const _hoisted_13 = { class: "type-selector-options" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "type-card-name" }
const _hoisted_16 = { class: "type-card-desc" }
const _hoisted_17 = { class: "name-input-row" }
const _hoisted_18 = {
  key: 0,
  class: "name-result"
}
const _hoisted_19 = {
  key: 0,
  class: "result-error"
}
const _hoisted_20 = {
  key: 1,
  class: "result-warning"
}
const _hoisted_21 = {
  key: 2,
  class: "result-success"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "upload-placeholder"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  class: "upload-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M544 864V288l264 264 60-60-368-368-368 368 60 60 264-264v576h88z",
    fill: "currentColor"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请上传营业执照", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_28 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_ui_tabbar2 = _resolveComponent("ui-tabbar2")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["status-banner", 'status-' + _ctx.auditStatus.type])
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.auditStatus.title), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.auditStatus.desc), 1),
      (_ctx.needPay && _ctx.authQrcode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.authName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.authName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: _ctx.authQrcode,
              alt: "微信认证二维码"
            }, null, 8, _hoisted_6),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.waitingTencentAudit && _ctx.dispatch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.dispatch.provider)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "审核公司：" + _toDisplayString(_ctx.dispatch.provider), 1))
              : _createCommentVNode("", true),
            (_ctx.dispatch.contact)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "联系方式：" + _toDisplayString(_ctx.dispatch.contact), 1))
              : _createCommentVNode("", true),
            (_ctx.dispatchTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "派单时间：" + _toDisplayString(_ctx.dispatchTime), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-position": "right",
      "label-width": "140px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["type-selector", { disabled: _ctx.readOnly }])
        }, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: _normalizeClass(["type-card", { selected: _ctx.formData.auth_data.customer_type === item.value }]),
                onClick: ($event: any) => (_ctx.selectCustomerType(item.value))
              }, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(item.desc), 1)
              ], 10, _hoisted_14))
            }), 128))
          ])
        ], 2),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "小程序信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "名称命名类型",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_tabbar2, {
                  modelValue: _ctx.formData.auth_data.account_name_type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.auth_data.account_name_type) = $event)),
                  disabled: _ctx.readOnly,
                  list: [{ name: '基于自选词汇命名', value: 1 }, { name: '基于商标命名', value: 2 }]
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_ui_form_item, {
              label: "小程序名称",
              data: _ctx.formData.auth_data.account_name,
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.auth_data.account_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.auth_data.account_name) = $event)),
                      disabled: _ctx.readOnly,
                      placeholder: "请输入小程序名称，请注意这是一次改名机会，也可用不修改"
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      disabled: _ctx.readOnly,
                      onClick: _ctx.checkName
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("检查名称")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  (_ctx.nameResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_ctx.nameResult.type == 'error')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.nameResult.message), 1))
                          : (_ctx.nameResult.data.hit_condition)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.nameResult.data.wording), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21, "恭喜该名称可用"))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "主体资质材料",
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["upload-zone", { disabled: _ctx.readOnly }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadFiles('auth_data.qualification')))
                }, [
                  (_ctx.showData[_ctx.formData.auth_data.qualification])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.auth_data.qualification],
                        class: "upload-preview"
                      }, null, 8, _hoisted_22))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "发票信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, { label: "开票信息" }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_tabbar2, {
                  list: _ctx.invoiceList,
                  disabled: _ctx.readOnly,
                  modelValue: _ctx.formData.auth_data.invoice_info.invoice_type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.auth_data.invoice_info.invoice_type) = $event))
                }, null, 8, ["list", "disabled", "modelValue"])
              ]),
              _: 1
            }),
            (_ctx.formData.auth_data.invoice_info.invoice_type == 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ui_form_item, {
                    label: "纳税识别号",
                    data: _ctx.formData.auth_data.invoice_info.electronic.id,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.auth_data.invoice_info.electronic.id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.auth_data.invoice_info.electronic.id) = $event)),
                        disabled: _ctx.readOnly,
                        placeholder: "请输入纳税人识别号"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, { label: "发票备注" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.auth_data.invoice_info.electronic.desc,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.auth_data.invoice_info.electronic.desc) = $event)),
                        disabled: _ctx.readOnly,
                        placeholder: "请输入发票备注"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "联系人信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "联系人姓名",
              data: _ctx.formData.auth_data.contact_info.name,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.auth_data.contact_info.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.auth_data.contact_info.name) = $event)),
                  disabled: _ctx.readOnly,
                  placeholder: "请输入联系人姓名"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "联系人邮箱",
              data: _ctx.formData.auth_data.contact_info.email,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.auth_data.contact_info.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.auth_data.contact_info.email) = $event)),
                  disabled: _ctx.readOnly,
                  placeholder: "请输入联系人邮箱"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _hoisted_27,
    _createElementVNode("div", _hoisted_28, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _ctx.submit,
        disabled: _ctx.readOnly,
        type: "primary",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.readOnly ? '审核中' : '提交信息'), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])), [
        [_directive_loading, _ctx.submitLoading]
      ])
    ])
  ]))
}